//@formatter:off
/**
 * @ngdoc directive
 * @name kpOnTransitionEnd
 * @module portaro.directives
 *
 * @restrict A
 * @element ANY
 *
 * @param {expression} kpOnTransitionEnd Expression is evaluated when given transition ends. Event object is available as `$event` parameter.
 *
 * @param {string} kpOnTransitionEndProperties Comma separated CSS properties on whose transition directive evaluates given expression.
 *
 * @description
 * Directive evaluates given expression on DOM `transitionend` event. List of CSS properties must be given in required kpOnTransitionEndProperties attribute.
 *
 * @example
 * <example module="kpOnTransitionEndExample" name="kpOnTransitionEndExample" frame-no-resize="true">
    <file name="index.html">
        <main ng-controller="exampleController as ec">
            <div class="opacity" ng-class="ec.opacity100 ? 'opacity-100' : 'opacity-20'" kp-on-transition-end="ec.transitionEnd()" kp-on-transition-end-properties="opacity"></div>
            <button type="button" ng-click="ec.changeOpacity()">Change Opacity</button>
        </main>
    </file>
    <file name="script.js">
        angular.module('kpOnTransitionEndExample', ['portaro.directives'])
            .controller('exampleController', class {
                constructor() {
                    this.opacity100 = true;
                }

                changeOpacity() {
                    this.opacity100 = !this.opacity100;
                }

                transitionEnd() {
                    alert('Transition ends');
                }
            });
    </file>
    <file name="style.css">
        .opacity {
            width: 100px;
            height: 100px;
            background-color: skyblue;

            transition: opacity 1s;
        }

        .opacity-100 {
            opacity: 1;
        }

        .opacity-20 {
            opacity: 0.2;
        }
    </file>
 * </example>
 */
//@formatter:on

export default class OnTransitionEndDirective {
    static directiveName = 'kpOnTransitionEnd';

    restrict = 'A';

    /*@ngInject*/
    constructor($parse) {
        this.$parse = $parse;
    }

    link($scope, $element, attrs) {
        const properties = attrs.kpOnTransitionEndProperties.split(',').map((e) => e.trim());

        $element.on(this.getTransitionEvent(), (event) => {
            // Workaround for jQuery event wrapper object
            event = event.originalEvent || event;
            // see https://stackoverflow.com/a/18689069
            if (properties.includes(event.propertyName)) {
                const fn = this.$parse(attrs[OnTransitionEndDirective.directiveName]);
                fn($scope, {$event: event});
                $scope.$applyAsync();
            }
        });
    }

    /**
     * Detect event name, supported by current browser.
     * @return {string} Detected event name
     */
    getTransitionEvent() {
        const el = document.createElement('fakeelement');

        const transitions = {
            'transition': 'transitionend',
            'OTransition': 'oTransitionEnd',
            'MozTransition': 'transitionend',
            'WebkitTransition': 'webkitTransitionEnd'
        };

        for (const t in transitions) {
            if (el.style[t] !== void 0) {
                return transitions[t];
            }
        }
    }
}